import { DropdownModule } from "primeng/dropdown";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ButtonModule } from "primeng/button";
import { SuperTaskModule } from "../superTask/superTask.module";
import { TableModule } from "primeng/table";
import { PaginatorModule } from "primeng/paginator";
import { CardModule } from "primeng/card";
import { MultiSelectModule } from "primeng/multiselect";
//import { PetitionUpdateInitComponent } from './components/task/update-petition-dialogue/petition-update-init/petition-update-init.component'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskComponent } from './components/task/task.component';
import { TaskListComponent } from './components/task/task-list/task-list.component';
import { TaskFormComponent } from './components/task/task-form/task-form.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PlatformStatisticsComponent } from './components/platform-statistics/platform-statistics.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { InformationGraphComponent } from './components/information-graph/information-graph.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { TaskPageComponent } from './components/task-page/task-page.component';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { TaskStatusDialogComponent } from './components/task-status-dialog/task-status.component';
import { TeamMembersListPreviewComponent } from './components/team-members-list-preview/team-members-list-preview.component';
import { LargeBannerAdComponent } from './components/large-banner-ad/large-banner-ad.component';
import { MicroBannerAdComponent } from './components/micro-banner-ad/micro-banner-ad.component';
import { MediumSizeBoxAdComponent } from './components/medium-size-box-ad/medium-size-box-ad.component';
import { ComingSoonAnnounceAdComponent } from './components/coming-soon-announce-ad/coming-soon-announce-ad.component';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { ProcessingTimeComponent } from './components/processing-time/processing-time.component';
import { TimeLineComponent } from './components/all-time-lines/time-line.component';
import { PetitionAuditLogComponent } from './components/task/petition-audit-log/petition-audit-log.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { PetitionDecisionComponent } from './components/petition-decision/petition-decision.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { ContactDetailsAttorneyComponent } from './components/contact-details-attorney/contact-details-attorney.component';
import { PetitionUpdateInitComponent } from './components/task/update-petition-dialogue/petition-update-init/petition-update-init.component'
import { InputNumberModule } from 'primeng/inputnumber';
import { JoyrideModule } from 'ngx-joyride';
import { FaqDashboardComponent } from './components/faq-dashboard/faq-dashboard.component';
import { I9FormComponent } from './components/i9-form/i9-form.component';
import { NextStepsComponent } from './components/next-steps/next-steps.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../core/http/http.service";
import { TimelineModule } from 'primeng/timeline';
import { LinkPetitionerComponent } from '../beneficiary/link-petitioner/link-petitioner.component';
import { TooltipModule } from 'primeng/tooltip';
import { SchedulingModule } from "../scheduling/scheduling.module";
import {PetitionerInvoiceViewComponent} from './components/petitioner-invoice-view/petitioner-invoice-view.component';
import {Calendar, CalendarModule} from 'primeng/calendar';
import {FileUploadModule} from 'primeng/fileupload';
import {HttpClientModule} from '@angular/common/http';
import {InputTextModule} from 'primeng/inputtext';
import { QuickAccessComponent } from './components/quick-access/quick-access.component';
import { VisaBulletinComponent } from './components/visa-bulletin/visa-bulletin.component';
import { IndividualsDateTrackerComponent } from './components/individuals-date-tracker/individuals-date-tracker.component';
import { TaskDeadlineComponent } from './components/task-deadline/task-deadline.component';
import { TodoChecklistComponent } from './components/todo-checklist/todo-checklist.component';
import { AddTodoModalComponent } from './components/add-todo-modal/add-todo-modal.component';
import { AddTodoCategoryModalComponent } from './components/add-todo-category-modal/add-todo-category-modal.component';
import { TodoListModalComponent } from './components/todo-list-modal/todo-list-modal.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    TaskComponent,
    TaskListComponent,
    TaskFormComponent,
    NotificationListComponent,
    PlatformStatisticsComponent,
    InformationGraphComponent,
    TaskPageComponent,
    TaskStatusDialogComponent,
    TeamMembersListPreviewComponent,
    LargeBannerAdComponent,
    MicroBannerAdComponent,
    MediumSizeBoxAdComponent,
    ComingSoonAnnounceAdComponent,
    ProfileCardComponent,
    ProcessingTimeComponent,
    TimeLineComponent,
    PetitionAuditLogComponent,
    PetitionDecisionComponent,
    ContactDetailsComponent,
    ContactDetailsAttorneyComponent,
    PetitionUpdateInitComponent,
    FaqDashboardComponent,
    I9FormComponent,
    NextStepsComponent,
    LinkPetitionerComponent,
    PetitionerInvoiceViewComponent,
    QuickAccessComponent,
    VisaBulletinComponent,
    IndividualsDateTrackerComponent,
    TaskDeadlineComponent,
    TodoChecklistComponent,
    AddTodoModalComponent,
    AddTodoCategoryModalComponent,
    TodoListModalComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatStepperModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatExpansionModule,
    HighchartsChartModule,
    MatIconModule,
    DragDropModule,
    MatDialogModule,
    OverlayPanelModule,
    DropdownModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    MultiSelectModule,
    InputNumberModule,
    NgxPermissionsModule.forChild(),
    DashboardRoutingModule,
    SharedModule,
    NgxMaskModule.forChild(),
    NgCircleProgressModule.forRoot(),
    DropdownModule,
    OverlayPanelModule,
    ButtonModule,
    CardModule,
    SuperTaskModule,
    NgCircleProgressModule.forRoot(),
    JoyrideModule.forChild(),
    PdfViewerModule,
    TimelineModule,
    TooltipModule,
    SchedulingModule,
    CalendarModule,
    FileUploadModule,
    HttpClientModule,
    InputTextModule,
    InfiniteScrollModule
  ],
  exports: [
    TaskComponent,
    TaskListComponent,
    MatExpansionModule,
    PlatformStatisticsComponent,
    MatCheckboxModule,
    MatStepperModule,
    MatCardModule,
    NotificationListComponent,
    InformationGraphComponent,
    TeamMembersListPreviewComponent,
    LargeBannerAdComponent,
    MicroBannerAdComponent,
    MediumSizeBoxAdComponent,
    ComingSoonAnnounceAdComponent,
    ProfileCardComponent,
    ProcessingTimeComponent,
    TimeLineComponent,
    ContactDetailsComponent,
    ContactDetailsAttorneyComponent,
    TaskPageComponent,
    TaskFormComponent,
    FaqDashboardComponent,
    I9FormComponent,
    NextStepsComponent,
    QuickAccessComponent,
    VisaBulletinComponent,
    IndividualsDateTrackerComponent,
    TaskDeadlineComponent,
    TodoChecklistComponent
  ],
  providers: [],
  entryComponents: [TaskStatusDialogComponent],
})
export class DashboardModule { }
